import MaskInput from "react-maskinput";
import { postReportSaga } from "../../store/sagas/postSaga";
import styles from "./textinput.module.scss";
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';


function NumberInput(props) {
    if (props.isCardInput) {
        return <div>
            <MaskInput placeholder={props.placeholder}
                value={props.value}
                onKeyDown={(e) => props.onKeyDown(e)}
                onFocus={() => props.onFocus()}
                onBlur={() => props.onBlur()}
                onChange={(e) => {
                    let value = e.target.value;
                    props.onChange(value);
                }}
                onClick={e => {
                    const valueLength = (e.target.value?.split('')?.filter(item => item !== ' ' && item !== '-')?.length);
                    if (valueLength === 0) {
                        e.target.setSelectionRange(0, 0);
                    }
                }}
                className={`${styles['card-input']}`} maskChar=" " mask="0000 0000 0000 0000" size={20} />
            {!props.valid && props.submitted ? <div
                className={props.first_childe ? styles.first_childe_error : styles.error}>
                {props.error_message}</div> : null}
        </div>;
    }

    return (
        <div
        // className={props.focused ? styles.number_focused_input : styles.number_input}
        >


            <Box>
                <TextField
                    id="demo-helper-text-aligned-no-helper"
                    label={props.placeholder}
                    // placeholder={props.placeholder}
                    value={props.value}
                    onKeyDown={(e) => props.onKeyDown(e)}
                    onFocus={() => props.onFocus()}
                    onBlur={() => props.onBlur()}
                    onChange={(e) => {
                        if (e.target.value.length <= props.maxLength) {
                            let value = e.target.value;
                            props.onChange(value);
                        }
                    }}
                    className="w-100  h-100"
                />
            </Box>



            {/* <input type="number" placeholder={props.placeholder}
                value={props.value}
                onKeyDown={(e) => props.onKeyDown(e)}
                onFocus={() => props.onFocus()}
                onBlur={() => props.onBlur()}
                onChange={(e) => {
                    if(e.target.value.length <= props.maxLength){
                        let value = e.target.value;
                        props.onChange(value)
                    }
                }}
                className="w-100  h-100" /> */}
            {!props.valid && props.submitted ? <div
                className={props.first_childe ? styles.first_childe_error : styles.error}>
                {props.error_message}</div> : null}
        </div>
    );
}
export default NumberInput;